import {useEffect} from "react";
import * as Api from "api/api";

function useFetchLiveRecord({liveId, setLiveRecord,setLiveGoodsList}) {
    useEffect(() => {
        if (!liveId) {
            return;
        }

        Api.currentLiveRecord({liveId}).then(data => {
            setLiveRecord(data.liveRecord)
            setLiveGoodsList(data.liveGoodsList)
        })
    }, [liveId])

}

export default useFetchLiveRecord;